import React from "react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickOrderDetailBanner from "@/features/pathpick/features/order-history/features/detail/components/overview-section/PathPickOrderDetailBanner";
import useAutoCancelCountdown from "@/features/pathpick/features/order-history/features/detail/hooks/useAutoCancelCountdown";
import { ORDER_DETAIL_KEY } from "@/features/pathpick/features/order-history/features/detail/constants";
import { PathPickOrder } from "@/features/pathpick/features/order-history/types/response";
import { selectPathPickOrderRemittanceView } from "@/features/pathpick/features/order-history/features/detail/utils";

interface Props {
  order: PathPickOrder;
}

/**
 * 입금 요청 상태의 상단 안내 배너.
 *
 * 기한이 지나도 서버 상태는 한동안 `입금 요청`으로 남아 있어, 입금 정보 카드의
 * 자동취소 박스와 같은 카운트다운을 물려 상·하단 문구가 함께 뒤집히게 한다.
 */
function PathPickOrderDetailRemittanceBanner({ order }: Props) {
  const { t } = useI18nHelper();
  const { dueAtLabel, autoCancelDueAt } =
    selectPathPickOrderRemittanceView(order);
  const remaining = useAutoCancelCountdown(autoCancelDueAt);
  // 기한 자체가 없으면 만료를 단정할 수 없으므로 입금 요청 문구를 유지한다.
  const isExpired = remaining?.isExpired ?? false;

  return (
    <PathPickOrderDetailBanner
      level={"warning"}
      title={t(
        `${ORDER_DETAIL_KEY}${
          isExpired
            ? "banner_payment_expired_title"
            : "banner_payment_request_title"
        }`
      )}
      description={t(
        `${ORDER_DETAIL_KEY}${
          isExpired
            ? "banner_payment_expired_desc"
            : "banner_payment_request_desc"
        }`,
        { dueAt: dueAtLabel ?? "-" }
      )}
    />
  );
}

export default PathPickOrderDetailRemittanceBanner;
